import React, { useMemo, useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getStream, deleteStream } from "service/api";
// import DeleteConfirmationModal from "./DeleteConfirmationModal"
import axios from 'axios';
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";


function DatatableTables() {
    const[alluserlist,setallusers] = useState({ users: [] });
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [selectedDeleteId, setSelectedDeleteId] = useState(null);

    useEffect(()  => {
        getallusers();
    }, []);

    const getallusers = async () => {
        let response = await getStream();
        if (response.error) {
            console.log('Error while fetching data:', response.error);      
        } else {
            setallusers({users: response.data});
            //console.log(response.data);
        }
    }

    const openDeleteModal = (id) => {
    setSelectedDeleteId(id);
    setIsConfirmOpen(true);
  };

  const closeDeleteModal = () => {
    setIsConfirmOpen(false);
    setSelectedDeleteId(null);
  };

  const confirmDelete = async () => {
    try {
      await deleteStream(selectedDeleteId);
      toast.success("Stream deleted successfully");
      getallusers();
    } catch (error) {
      toast.error("Failed to delete stream");
      console.error("Delete error:", error);
    } finally {
      closeDeleteModal();
    }
  };



    // const openDeleteModal = rowData => {
    //     setSelectedDeleteData(rowData)
    //     setIsDeleteModalOpen(true)
    //   }
    
    //   const closeDeleteModal = () => {
    //     setSelectedDeleteData(null)
    //     setIsDeleteModalOpen(false)
    //   }
    //   const handleDelete = async () => {
    //     try {
    //       if (selectedDeleteData) {
    //         await deleteuser(selectedDeleteData);       
    //           closeDeleteModal();    
    //           getallusers();      
    //       }
    //     } catch (error) {
    //       console.error(error)
    //     }
    //   }

    const columns = useMemo(
        () => [
            {
                Header: 'Stream Name',
                accessor: 'name',
            },
            {
                Header: 'Color',
                accessor: 'color'
            },
            // {
            //     Header: 'Mobile',
            //     accessor: 'mobile'
            // },
            // {
            //     Header: 'Role',
            //     accessor: 'userType'
            // },
            {
                Header: "Action",
                Cell: ({ row }) => {
                  const id = row.original._id; 
                  return (
                    <>
                      <button className="btn btn-danger mx-2"
                     onClick={() => openDeleteModal(id)}
                    > <i className="mdi mdi-trash-can font-size-15"></i> </button>
                    </>
                  )
                },
              },
        ],
        []
    );
    //meta title
    document.title = "Stream | List";

    return (
        <div className="page-content">
            <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-4">
             <h1 className="page-title"></h1>
             <Link to="/Addstream" className="btn btn-primary">ADD NEW Stream</Link>
            </div>
                <Breadcrumbs title="Setting" breadcrumbItem="Stream" />
                <TableContainer
                        columns={columns}
                        data={alluserlist.users}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        customPageSize={10}
                        className="custom-header-css"
                />
        {/* <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        /> */}
        <Modal isOpen={isConfirmOpen} toggle={closeDeleteModal} centered>
          <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this stream?
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={confirmDelete}>Yes, Delete</Button>
            <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
            </div>
        </div>
    );
}

export default DatatableTables;